<template>
    <div class="w-100 h-100">
        <div v-if="!loading" id="received-files-main" class="bg-white w-100 h-100">
            <table class="table table-hover">
                <tbody>
                    <received-files-entry v-for="file in file.received" :file="file" :key="file.Id"></received-files-entry>
                </tbody>
            </table>
        </div>
        <div v-else class="bg-white w-100 h-100">
            <table class="table">
                <tbody>
                    <received-files-entry-placeholder v-for="n in rows" :key="n"></received-files-entry-placeholder>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import ReceivedFilesEntry from './received-files-entry'
import ReceivedFilesEntryPlaceholder from './received-files-entry-placeholder'
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            loading: true,
            rows: 8
        }
    },
    props: {
        folderId: Number
    },
    components: {
        ReceivedFilesEntry,
        ReceivedFilesEntryPlaceholder
    },
    created() {
        //this.$store.dispatch('file/fetchReceivedFiles', this.parsedFolderId)
        this.fetchReceivedFiles(this.parsedFolderId)
            .then(() => {
                console.log('callback success')
                let comp = this
                setTimeout(function() {
                    comp.loading = false
                }, 600)
            })
    },
    methods: {
        ...mapActions('file', ['fetchReceivedFiles']),
        testFunction() {
            console.log('testing callback')
        }
    },
    computed: {
        ...mapState(['file', 'received']),
        parsedFolderId() {
            return parseInt(this.folderId)
        }
    }
}
</script>
<style scoped>
    #received-files-main {
        overflow-y: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/received-files-view/received-files-main.vue